import React, { useState } from 'react'
import { alertActions, regisActions } from '../../../store/actions'
import { connect } from 'react-redux'
import Input from '../../../module/input'

const UtradeHubLoginPopup = (props) => {
  const [state, setState] = useState({
    uthId: '',
    uthPasswd: '',
  })
  const handleChange = (e) => {
    const { name, value } = e.target
    setState({
      ...state,
      [name]: value,
    })
  }

  let style = {
    backgroundColor: 'rgb(0, 0, 0)',
    position: 'fixed',
    inset: '0px',
    opacity: '0.6',
    zIndex: '997',
  }

  const popup = document.getElementById('uTradeHub-info')
  const _height = popup?.offsetHeight
  const top = document.body.clientHeight / 2 - _height / 2 + document.body.scrollTop
  const left = document.body.clientWidth / 2 + document.body.scrollLeft

  let styleModal = {
    top: top ? top : '215.906px',
    left: left ? left : '735px',

    position: 'absolute',
    display: 'block',
    opacity: '1',
    zIndex: '998',
  }

  const checkUthInfo = (e) => {
    e.preventDefault()

    if (!state.uthId) {
      return props.error({ message: '아이디를 입력하세요.' })
    }
    if (!state.uthPasswd) {
      return props.error({ message: '비밀번호를 입력하세요.' })
    }

    props.getUthInfo(state.uthId, state.uthPasswd)
  }

  return (
    <React.Fragment>
      <div style={style}></div>
      <div id="uTradeHub-info" className="modal w450" style={styleModal}>
        <div className="modal-head">
          <h2>uTradeHub 회원정보 조회하기</h2>
        </div>
        <div className="modal-cont">
          <dl className="dl-form">
            <dt>아이디</dt>
            <dd>
              <Input
                type="text"
                className="form-control"
                placeholder="아이디를 입력해주세요"
                id="id"
                name="uthId"
                value={''}
                onChange={handleChange}
              />
            </dd>
            <dt>비밀번호</dt>
            <dd>
              <Input
                type="password"
                className="form-control"
                placeholder="비밀번호를 입력해주세요"
                id="passwd"
                name="uthPasswd"
                value={''}
                onChange={handleChange}
              />
            </dd>
          </dl>
          <div>
            <span>* uTradeHub에 가입된 아이디/비밀번호를 입력해주세요</span>
          </div>
          <div className="btn-block center">
            <a
              className="btn-secondary md b-close cursor"
              onClick={(e) => {
                e.preventDefault()
                props.onChange(false)
              }}
            >
              취소
            </a>
            <a className="btn-primary md b-close cursor" onClick={checkUthInfo}>
              확인
            </a>
          </div>
        </div>
        <button
          onClick={() => {
            props.onChange(false)
          }}
          type="button"
          className="modal-close b-close"
        >
          창닫기
        </button>
      </div>

      {/* <Alert /> */}
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    uthIsJoinYn: state.uthIsJoinYn,
  }
}
const actionCreators = {
  error: alertActions.error,
  success: alertActions.success,
  getUthInfo: regisActions.getUthInfo,
  checkedJoinFlag: regisActions.checkedJoinFlag,
}

export default connect(mapStateToProps, actionCreators)(UtradeHubLoginPopup)
